// import { StyleSheet, Text, View } from 'react-native'

import { Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'

const Terms = () => {
  const [isLargeScreen, setIsLargeScreen] = useState(false); // Mide el tamaño de la pantalla para hacer el diseño responsive


  useEffect(() => {
          const handleResize = () => {
              setIsLargeScreen(window.innerWidth >= 768); // set the breakpoint here
          };
          handleResize();
          window.addEventListener('resize', handleResize);
          return () => window.removeEventListener('resize', handleResize);
      }, []);


  return (
    <div style={{height: '100vh', margin: 64, marginInline: (isLargeScreen ? 128 : null)}}>
      <Typography variant="h5" marginBottom={4}>Términos y Condiciones.</Typography>

      <Typography variant={isLargeScreen ? "h6" : "h7"}>Todo el contenido publicado en este sitio web, incluyendo texto, código y diseño, es propiedad exclusiva de HiSocialize. Está prohibido copiar, distribuir o modificar dicho contenido sin el consentimiento explícito por escrito.</Typography>
    </div>
  )
}

export default Terms
